import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["northbeam"],
  iconColor: "#7081FF", // cosmic
  getIcon(options) {
    return createIcon(
      `<path
        d="M20.983 7H19.7442L16.5661 12.8685L15.4186 11.8L18.014 7.00686L17.9981 7H16.7593L14.5811 11.0218L13.6363 10.1425L15.3347 7.00686L15.3177 7H14.079L11.7988 11.2109L10.2947 9.81121H9.60046L8.93171 11.0365L7.61438 9.81121H6.92015L3 17H4.26107L7.45727 11.1413L8.39777 12.0167L5.67925 17H6.94032L9.23424 12.7949L10.3775 13.8594L8.66421 17H9.92528L12.1162 12.9831L13.4835 14.2545H14.0896L14.8868 12.7832L16.4695 14.2554H17.0756L21 7.00784L20.983 7ZM10.6991 12.8685L9.76924 12.0029L10.2405 11.1394L11.1683 12.002L10.6991 12.8685ZM13.5811 12.8685L12.6512 12.0029L13.1225 11.1394L14.0503 12.002L13.5811 12.8685Z" fill="#7081FF"
      />`,
      "#F9FAFF", // cosmic-5
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
